import styled from 'styled-components';
import {Star} from '../Rating/Rating.style';
import {media} from '../../styles/components/media-queries';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: -0.2rem;
`;

export const DisplayStar = styled(Star)`
  cursor: default;
  width: ${props => props.$size || '1.4rem'};
  height: ${props => props.$size || '1.4rem'};
  margin-right: ${props => props.$gap || '0.5rem'};
  &::before {
    font-size: ${props => props.$fontSize || '2.6rem'};
    padding-top: 0;
    padding-right: 0.2rem;
    margin-top: ${props => props.$marginTop || '-0.7rem'};
    position: absolute;
    color: ${props =>
      props.$rated ? props.theme.ratingColor : props.theme.borderDarkColor};
  }

  ${media.small`
    width: ${props => props.$sizeDesktop || props.$size || '1.8rem'};
    height: ${props => props.$sizeDesktop || props.$size || '1.8rem'};

    &::before {
      font-size: ${props =>
        props.$fontSizeDesktop || props.$fontSize || '2.8rem'};
    }
  `};
`;

export const HalfDisplayStar = styled(DisplayStar)`
  &::before {
    background: linear-gradient(
      to right,
      ${props => props.theme.ratingColor} 50%,
      ${props => props.theme.borderDarkColor} 50%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    color: transparent;
  }
`;

export const ReviewCount = styled.span`
  color: ${props => props.theme.textColor};
  font-size: ${props => props.$reviewFontSize || '1.2rem'};
  margin-left: 10%;
`;
